export const PageModeTypes = {
  Catalogue: "catalogue",
  DIY: "diy"
};



// WEBPACK FOOTER //
// ./src/views/components/page_modes/PageModeTypes.js